import { useDispatch } from 'react-redux';

import ErrorModal from '@/components/UploadPDF/ErrorModal';
import { useShallowEqualSelector } from '@/hooks';
import { setIsModalErrorOpen } from '@/store/myDocuments';

function ModalErrorUploadPdf() {
	const dispatch = useDispatch();
	const { isModalErrorOpen, modalErrorCode } = useShallowEqualSelector(
		({ myDocuments }) => ({
			isModalErrorOpen: myDocuments.isModalErrorOpen,
			modalErrorCode: myDocuments.modalErrorCode
		})
	);

	return (
		<ErrorModal
			open={isModalErrorOpen}
			errorCode={modalErrorCode}
			onClose={() => dispatch(setIsModalErrorOpen(false))}
		/>
	);
}

export default ModalErrorUploadPdf;
